var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 9.5L5.25 12.5V10.25H12V8.75H5.25V6.5L1.5 9.5Z",
    fill: "#EA5455"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75054 2.74923C8.86368 2.74677 7.98516 2.92032 7.16585 3.25981C6.34654 3.59929 5.60274 4.09798 4.97754 4.72698L6.03804 5.78748C7.02954 4.79598 8.34804 4.24923 9.75054 4.24923C11.153 4.24923 12.4715 4.79598 13.463 5.78748C14.4545 6.77898 15.0013 8.09748 15.0013 9.49998C15.0013 10.9025 14.4545 12.221 13.463 13.2125C12.4715 14.204 11.153 14.7507 9.75054 14.7507C8.34804 14.7507 7.02954 14.204 6.03804 13.2125L4.97754 14.273C6.25179 15.548 7.94679 16.2507 9.75054 16.2507C11.5543 16.2507 13.2493 15.548 14.5235 14.273C15.7985 12.9987 16.5013 11.3037 16.5013 9.49998C16.5013 7.69623 15.7985 6.00123 14.5235 4.72698C13.8983 4.09798 13.1545 3.59929 12.3352 3.25981C11.5159 2.92032 10.6374 2.74677 9.75054 2.74923Z",
    fill: "#EA5455"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/log-out.ed1d66009a00d70d5bfe5b48e97deba6.svg";
export { ForwardRef as ReactComponent };